import { Link } from 'react-router-dom'
import { formatCountBrowser, useCommonT } from '../../i18n'
import { trackEvent } from '../../lib/analytics'
import { CardStackIcon } from '../shared/TileIcons'

/**
 * Returning-hub collection band. Parent gates rendering on collectionId, so
 * this renders only for users with a collection; a missing count degrades to
 * the label alone rather than blocking on a fetch. The stored count is the
 * number of unique names (every import saves unique_count), and is labelled
 * as such.
 */
export default function CollectionStrip({ cardCount }: { cardCount: number | null }) {
  const t = useCommonT()
  return (
    <section className="surface p-4 flex flex-wrap items-center gap-3 text-left">
      <CardStackIcon className="w-7 h-7 shrink-0 text-purple-400" />
      <span className="flex-1 min-w-40">
        <span className="block text-[15px] font-semibold text-white">{t('home.collection.title')}</span>
        <span className="block text-[13px] text-gray-500 mt-0.5">
          {cardCount != null
            ? t('home.collection.count_unique', { n: formatCountBrowser(cardCount) })
            : t('home.collection.empty')}
        </span>
      </span>
      <span className="flex gap-2">
        <Link
          to="/collection"
          onClick={() => trackEvent('home_collection_clicked', { to: 'collection' })}
          className="text-sm font-medium text-purple-300 hover:text-purple-200 px-3 py-2 transition-colors"
        >
          {t('home.collection.view')}
        </Link>
        <Link
          to="/build"
          onClick={() => trackEvent('home_collection_clicked', { to: 'build' })}
          className="text-sm font-semibold text-white bg-purple-600 hover:bg-purple-500 rounded-lg px-3 py-2 transition-colors"
        >
          {t('home.collection.build')}
        </Link>
      </span>
    </section>
  )
}
